<div class="mt-3" id="expertCard">
  <div
    class="hover:bg-primary-light relative flex items-center justify-between grow border border-gray-200 rounded-xl gap-2 p-5 [background-position:220%_44%] bg-no-repeat bg-[length:650px] user-access-bg"
  >
    <!-- Close Icon -->
    <button
      onclick="document.getElementById('expertCard').remove()"
      class="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
    >
      &times;
    </button>

    <div class="flex items-center gap-4">
      <img
        src="https://developmentcontent.blob.core.windows.net/resources/dashboard/Analysis.png"
        class="h-120px w-100px"
      />
      <div class="flex flex-col gap-1.5">
        <div class="flex items-center gap-2.5">
          <a
            class="text-base font-semibold text-gray-900 hover:text-primary-active"
          >
            For More Deeper Analysis Talk To Our Expert
          </a>
        </div>
        <div class="form-info">
          Engage with our expert for comprehensive analysis and personalized
          insights tailored to your needs.
        </div>
      </div>
    </div>
    <div class="flex items-center gap-1.5 relative">
      <div class="relative">
        <a
          href="mailto:info@eciso.tech"
          class="btn btn-sm btn-primary relative text-center"
        >
          Consult Now
        </a>
      </div>
    </div>
  </div>
</div>
